import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://emrdowvdoxpmaaqmanqw.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVtcmRvd3Zkb3hwbWFhcW1hbnF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODcxMTY2OTUsImV4cCI6MjEwMjY5MjY5NX0.-gpClcA3mnxqS8qRf8c5uyIJhFtupuQNBzXYHrpDDoI';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});